import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "As a registered courier, we have guaranteed submission availability at the Miami Passport Agency",
      "Ideal for Lakeland Linder and Tampa International flyers",
      "Perfect for Polk County families planning international vacations",
      "Great for Southeastern University and Florida Poly students studying abroad",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Polk County post offices",
      "Good for planned international trips from Lakeland",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection and restart the clock",
      "In-person clerk appointment required at Polk County facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Miami — ~280 miles via I-4 and I-75; as a registered courier, we submit on your behalf",
      "NPIC appointment required before driving to Miami",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Florida has only one passport agency serving 22M+ residents statewide",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function ProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      sectionId="processing-options"
      cityName="Lakeland"
      headingExtra="FL"
      introText="Lakeland and Polk County travelers — Lakeland Linder International Airport flyers connecting through Tampa and Orlando, Southeastern University and Florida Polytechnic University students studying abroad, Publix corporate employees on international business travel, Sun 'n Fun Aerospace Expo international visitors, and Central Florida families planning vacations to Europe and the Caribbean — have several options for getting a passport fast. Here is how they compare, and why most Central Florida residents choose a U.S. Department of State registered passport courier with guaranteed submission availability at the Miami Passport Agency."
      options={options}
      emergencyDescription="Florida has only one regional passport agency — in Miami, roughly 280 miles from Lakeland via I-4 and I-75. I-4 construction and seasonal traffic make the trip unpredictable. You must obtain an NPIC appointment before traveling, and walk-ins are not accepted at the Miami Passport Agency. As a registered courier, we have guaranteed submission availability so you bypass these travel hurdles entirely."
      disclaimerText="*Processing speed depends on eligibility and documentation. Florida has only one regional passport agency — in Miami, roughly 280 miles away. Not all applicants qualify for Regional Agency Processing."
    />
  );
}